/* eslint-disable */

/** unique or primary key constraints on table "argo.calendar_event_udf_schema" */
export enum ArgoCalendarEventUdfSchemaConstraint {
  /** unique or primary key constraint on columns "udf_column_id", "context_id" */
  CalendarEventUdfSchemaEnforceUnique = 'calendar_event_udf_schema_enforce_unique',
  /** unique or primary key constraint on columns "calendar_event_udf_schema_id" */
  CalendarEventUdfSchemaPkey = 'calendar_event_udf_schema_pkey'
}

/** select columns of table "argo.calendar_event_udf_schema" */
export enum ArgoCalendarEventUdfSchemaSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UdfColumnType = 'udf_column_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.calendar_event_udf_schema" */
export enum ArgoCalendarEventUdfSchemaUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UdfColumnType = 'udf_column_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

